import { RequestEditStatusModalStatusField } from '../RequestEditStatusModalStatusField'

function RequestEditStatusModalFields() {
  return <RequestEditStatusModalStatusField />
}

export default RequestEditStatusModalFields
